import { Navigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { SITE_URL, SITE_NAME, DEFAULT_OG_IMAGE, absoluteUrl, getPageMeta } from "@/lib/pageSeo";

/**
 * Kaldırılan/eski adresler için istemci tarafı yönlendirme + canonical sinyali.
 *
 * Yönlendirme JS ile yapıldığından tarayıcı olmayan botlar eski URL'de 200
 * görebilir. Canonical, og:url ve hedef sayfanın OG/Twitter meta etiketleri
 * paylaşım önizlemesinin doğru sayfayı göstermesini sağlar.
 */
export const CanonicalRedirect = ({ to }: { to: string }) => {
  const { i18n } = useTranslation();
  const target = `${SITE_URL}${to}`;
  const meta = getPageMeta(to, i18n.language);
  const imageUrl = absoluteUrl(meta?.image ?? DEFAULT_OG_IMAGE);

  return (
    <>
      <Helmet>
        <link rel="canonical" href={target} />
        <meta property="og:site_name" content={SITE_NAME} />
        <meta property="og:url" content={target} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={imageUrl} />
        <meta property="og:image:alt" content={meta?.imageAlt ?? SITE_NAME} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content={imageUrl} />
        {meta && <title>{meta.title}</title>}
        {meta && <meta name="description" content={meta.description} />}
        {meta && <meta property="og:title" content={meta.title} />}
        {meta && <meta property="og:description" content={meta.description} />}
        {meta && <meta name="twitter:title" content={meta.title} />}
        {meta && <meta name="twitter:description" content={meta.description} />}
      </Helmet>
      <Navigate to={to} replace />
    </>
  );
};

export default CanonicalRedirect;
